module.exports = __webpack_public_path__ + "static/media/1682335776214-1666175377412-PaulSurin_1.b50bcb9d.jpg";